import { Option } from '@/common/components/PillsPicker/PillsPicker';

/**
 * Sums values from array till given index.
 * @param array
 * @param index
 * @returns sum of numbers
 */
export const sumValuesFrom = (array: number[], index: number) =>
  array.reduce((acc, item, i) => acc + (i < index ? item : 0), 0);

/**
 * If the array of otions does not have a 'value' field specified - use
 * index from the loop.
 * @param options
 * @returns options array
 */
export const mapPillsPickerOptions = <ValueType>(options: Option<ValueType>[]) => {
  return options.map((option, i) => ({ ...option, value: option.value || i }));
};
